// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'


const QUIZ_ADDING_FRIEND = 'QUIZ_ADDING_FRIEND'
const QUIZ_ADDED_FRIEND = 'QUIZ_ADDED_FRIEND'
const QUIZ_RECEIVED_FRIENDS = 'QUIZ_RECEIVED_FRIENDS'
const QUIZ_RECEIVED_QUIZ_ANSWER = 'QUIZ_RECEIVED_QUIZ_ANSWER'
const QUIZ_RECEIVED_QUIZ_BY_ID = 'QUIZ_RECEIVED_QUIZ_BY_ID'
const QUIZ_RECEIVED_RESULTS = 'QUIZ_RECEIVED_RESULTS'
const QUIZ_RECEIVED_QUIZ_STEP = 'QUIZ_RECEIVED_QUIZ_STEP'
const QUIZ_RECEIVED_QUIZ_TYPES = 'QUIZ_RECEIVED_QUIZ_TYPES'
const QUIZ_GENERATED_QUIZ = 'QUIZ_GENERATED_QUIZ'
const QUIZ_STARTED_QUIZ = 'QUIZ_STARTED_QUIZ'
const QUIZ_IS_FETCHING_FRIENDS = 'QUIZ_IS_FETCHING_FRIENDS'
const QUIZ_RESET_ADD_FRIEND = 'QUIZ_RESET_ADD_FRIEND'
const QUIZ_SURVEY_ANSWERED = 'QUIZ_SURVEY_ANSWERED'
const QUIZ_RECEIVED_SURVEY = 'QUIZ_RECEIVED_SURVEY'


const initialState = {
  quizTypes: [],
  currentQuizType: '62d022f8-0b39-4a09-9387-2ecc3b522f19',
  currentQuestion: 0,
  questionOrder: [],
  question: {
    uuid: '',
    sort_order: '',
    time: 0,
    question: '',
    description: '',
    quiz_type_uuid: '',
    type: '',
    metadata: {},
    started_at: null,
    completed_at: null,
  },
  quiz: {
    uuid: '',
    email: '',
    quiz_type_uuid: '',
    started_at: null,
    completed_at: null,
    questions: [],
  },
  authenticationStatus: 'PENDING',
  results: {
    my_score: null,
    my_answers: [],
    avg_team_score: null,
    team_size: 0,
    industry_average: 0,
  },
  friends: [],
  hasReceivedFriends: false,
  hasAddedFriend: false,
  isAddingFriend: false,
  surveyAnswered: false,
  surveyLoaded: false,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case QUIZ_ADDING_FRIEND:
      return {
        ...state,
        hasAddedFriend: false,
      }
    case QUIZ_ADDED_FRIEND:
      return {
        ...state,
        hasAddedFriend: true,
        isAddingFriend: false,
      }
    case QUIZ_IS_FETCHING_FRIENDS:
      return {
        ...state,
        isAddingFriend: true,
      }
    case QUIZ_RESET_ADD_FRIEND:
      return {
        ...state,
        hasAddedFriend: false,
        isAddingFriend: false,
      }
    case QUIZ_RECEIVED_FRIENDS:
      return {
        ...state,
        friends: action.friends,
        hasReceivedFriends: true,
      }
    case QUIZ_RECEIVED_QUIZ_ANSWER:
      return {
        ...state,
        question: action.question,
      }
    case QUIZ_RECEIVED_QUIZ_STEP:
      return {
        ...state,
        question: action.question,
      }
    case QUIZ_RECEIVED_RESULTS:
      return {
        ...state,
        results: action.results,
      }
    case QUIZ_RECEIVED_QUIZ_TYPES:
      return {
        ...state,
        quizTypes: action.quizTypes,
      }
    case QUIZ_GENERATED_QUIZ:
      return {
        ...state,
        quiz: action.quiz,
      }
    case QUIZ_RECEIVED_QUIZ_BY_ID:
      return {
        ...state,
        quiz: action.quiz,
      }
    case QUIZ_STARTED_QUIZ:
      return {
        ...state,
        quiz: {
          ...state.quiz,
          started_at: action.started_at,
        },
      }
    case QUIZ_SURVEY_ANSWERED:
      return {
        ...state,
        surveyAnswered: true,
      }
    case QUIZ_RECEIVED_SURVEY:
      return {
        ...state,
        surveyAnswered: action.surveyAnswered,
        surveyLoaded: true,
      }
    default:
      return state
  }
}

export function generateQuiz() {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz`,
      idToken: state.auth.user.idToken,
      params: {
        quiz_type_uuid: state.quiz.currentQuizType,
      },
    })
      .then((response) => {
        dispatch({
          type: QUIZ_GENERATED_QUIZ,
          quiz: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function resetQuiz() {
  return (dispatch, getState) => {
    const state = getState()
    return api({
      method: 'post',
      url: `${settings.urls.quiz}/quiz`,
      idToken: state.auth.user.idToken,
      data: {
        quiz_type_uuid: state.quiz.currentQuizType,
      },
    })
      .then((response) => {
        dispatch({
          type: QUIZ_GENERATED_QUIZ,
          quiz: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getQuizById(uuid) {
  return (dispatch) => {
    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz/${uuid}`,
    })
      .then((response) => {
        const questionOrder = []
        response.data.questions.map((question) => {
          questionOrder.push(question.uuid)
        })
        dispatch({
          type: QUIZ_RECEIVED_QUIZ_BY_ID,
          quiz: response.data,
          questionOrder,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getQuizTypes() {
  return (dispatch) => {
    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz/types`,
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_QUIZ_TYPES,
          quizTypes: response.data.types,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function startQuiz(quizId) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.quiz}/quiz/${quizId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: QUIZ_STARTED_QUIZ,
          started_at: response.data.quiz.started_at,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getQuizStep(quizId, questionId) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz/${quizId}/${questionId}`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_QUIZ_STEP,
          question: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function postQuizAnswer(quizId, questionId, answer, code, engine) {
  return (dispatch, getState) => {
    const state = getState()
    let encodedCode = code
    if (encodedCode !== null) {
      encodedCode = btoa(code)
    }

    return api({
      method: 'post',
      url: `${settings.urls.quiz}/quiz/${quizId}/${questionId}`,
      idToken: state.auth.user.idToken,
      data: {
        answer,
        code: encodedCode,
        engine,
      },
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_QUIZ_ANSWER,
          question: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getQuizResults(quizId) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz/${quizId}/results`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_RESULTS,
          results: response.data,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function addFriend(friendName, friendEmail, myName, myScore) {
  return (dispatch, getState) => {
    dispatch({
      type: QUIZ_ADDING_FRIEND,
    })
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.quiz}/friends`,
      idToken: state.auth.user.idToken,
      data: {
        friend_email: friendEmail,
        friend_name: friendName,
        my_name: myName,
        my_score: myScore,
      },
    })
      .then(() => {
        dispatch({
          type: QUIZ_ADDED_FRIEND,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function resetAddFriend() {
  return (dispatch) => {
    dispatch({
      type: QUIZ_RESET_ADD_FRIEND,
    })
  }
}

export function getFriends(quizTypeId) {
  return (dispatch, getState) => {
    dispatch({
      type: QUIZ_ADDING_FRIEND,
    })
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.quiz}/friends`,
      idToken: state.auth.user.idToken,
      params: {
        quiz_type: quizTypeId,
      },
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_FRIENDS,
          friends: response.data.friends,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function getSurveyAnswer(quizId) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'get',
      url: `${settings.urls.quiz}/quiz/${quizId}/survey/2a70fef2-37e5-4e08-90fd-124441d3e4d5`,
      idToken: state.auth.user.idToken,
    })
      .then((response) => {
        dispatch({
          type: QUIZ_RECEIVED_SURVEY,
          surveyAnswered: response.data.answer,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export function postSurveyAnswer(quizId, answer) {
  return (dispatch, getState) => {
    const state = getState()

    return api({
      method: 'post',
      url: `${settings.urls.quiz}/quiz/${quizId}/survey/2a70fef2-37e5-4e08-90fd-124441d3e4d5`,
      idToken: state.auth.user.idToken,
      data: {
        answer,
      },
    })
      .then(() => {
        dispatch({
          type: QUIZ_SURVEY_ANSWERED,
        })
      })
      .catch((error) => {
        console.error(error)
      })
  }
}
